
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 51 33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M43.126 0c-1.73 0-3.504.379-5.25 1.156L9.626 13.781a.553.553 0 01-.219.063c-.234 0-.64-.324-1-.594-1.351-.996-3.32-2.426-3.937-2.906-.465-.356-1.11-.563-1.813-.563-1.039 0-1.902.414-2.343 1.094-.36.555-.422 1.238-.125 1.906l3.562 7.906c.43.965 1.543 2.125 4.406 2.125 3.258 0 8.313-1.5 14.625-4.312l1.313-.594-2.281 12.219c-.274 1.098-.235 1.844.156 2.344.25.32.625.5 1.031.5.203 0 .414-.032.625-.125l1.563-.688c1.175-.523 2.433-2.144 3-3.375l7.437-16.093c14.23-6.665 14.871-8.075 14.25-9.47C49.161 1.622 46.622 0 43.126 0zm-29.25 1.938c-.562 0-1.371.062-2 .343l-1.562.688c-.516.23-.856.672-.875 1.187-.032.965.949 1.578 1.625 1.938l4.593 2.812 9.063-4.062-8.375-2.563a8.628 8.628 0 00-2.469-.344z","fill":"#000"}})])
          )
        }
      }
    